module.exports = __webpack_public_path__ + "img/10-6b.9314732f.jpg";